export default class ShowMenu {

	constructor() {
		this.init();
	}

	init() {

	const mobileMenuButton = document.querySelector('.mobile-menu-button');
	const mobileMenuButtonClose = document.querySelector('.mobile-list__close-button');
	const mobileList = document.querySelector('.mobile-list');
	const bg2 = document.querySelector('.eagerlyicon-bg2');
	const bgSmall = document.querySelector('.eagerlyicon-bg-small1');
	const screen = document.documentElement.scrollHeight;

	mobileMenuButton.addEventListener('click', function() {

	mobileList.classList.remove('hide-menu');
	mobileList.classList.add('show-menu');

	if (document.body.classList.contains('bg2-container')) {
		bg2.classList.add('hide-bg');
	}

	if (document.body.classList.contains('bg-small1-container')) {
		bgSmall.classList.add('hide-bg');
	}
	document.body.classList.add('screen-height');
	});

	mobileMenuButtonClose.addEventListener('click', function() {
	mobileList.classList.remove('show-menu');
	mobileList.classList.add('hide-menu');
	document.body.classList.remove('screen-height');

	if (document.body.classList.contains('bg2-container') && screen > 3900) {
		bg2.classList.remove('hide-bg');
	}

	if (document.body.classList.contains('bg-small1-container') && screen > 3900) {
		bgSmall.classList.remove('hide-bg');
	}

	});
	}
}
